import React from 'react';
import { Link } from 'react-router-dom';
import {MapPin, Calendar, DollarSign} from 'lucide-react';

interface DestinationCardProps {
  name: string;
  slug: string;
  image: string;
  description: string;
  bestTime: string;
  budget: string;
  highlights: string[];
}

export default function DestinationCard({
  name,
  slug,
  image,
  description,
  bestTime,
  budget,
  highlights
}: DestinationCardProps) {
  return (
    <Link
      to={slug}
      className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
    >
      <div className="relative h-64 overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
        <h3 className="absolute bottom-4 left-4 text-3xl font-bold text-white">{name}</h3>
      </div>

      <div className="p-6">
        <p className="text-gray-600 mb-4 line-clamp-2">{description}</p>

        <div className="space-y-2 mb-4">
          <div className="flex items-center text-sm text-gray-700">
            <Calendar className="w-4 h-4 mr-2 text-[#4A90E2]" />
            <span className="font-medium">Best Time:</span>
            <span className="ml-2">{bestTime}</span>
          </div>
          <div className="flex items-center text-sm text-gray-700">
            <DollarSign className="w-4 h-4 mr-2 text-[#F7B32B]" />
            <span className="font-medium">Budget:</span>
            <span className="ml-2">{budget}</span>
          </div>
        </div>

        <div className="border-t pt-4">
          <div className="flex items-start">
            <MapPin className="w-4 h-4 mr-2 text-[#FF6B35] mt-1 flex-shrink-0" />
            <div className="flex-1">
              <p className="text-xs text-gray-500 mb-1">Top Highlights:</p>
              <p className="text-sm text-gray-700 line-clamp-2">{highlights.join(' • ')}</p>
            </div>
          </div>
        </div>

        <div className="mt-4 text-[#FF6B35] font-semibold text-sm group-hover:text-[#0A2540] transition-colors">
          Explore {name} →
        </div>
      </div>
    </Link>
  );
}
